/**
 * Validates character alignment data for consistency
 * Returns validation errors or null if valid
 */
export function validateCharacterAlignment(alignment) {
    if (!alignment) {
        return null; // Alignment is optional, so undefined is valid
    }
    const errors = [];
    // Check that all arrays exist
    if (!Array.isArray(alignment.characters)) {
        errors.push("characters is not an array");
    }
    if (!Array.isArray(alignment.character_start_times_seconds)) {
        errors.push("character_start_times_seconds is not an array");
    }
    if (!Array.isArray(alignment.character_end_times_seconds)) {
        errors.push("character_end_times_seconds is not an array");
    }
    if (errors.length > 0) {
        return errors;
    }
    // Check that all arrays have the same length
    const charCount = alignment.characters.length;
    if (alignment.character_start_times_seconds.length !== charCount) {
        errors.push(`character_start_times_seconds length (${alignment.character_start_times_seconds.length}) ` +
            `doesn't match characters length (${charCount})`);
    }
    if (alignment.character_end_times_seconds.length !== charCount) {
        errors.push(`character_end_times_seconds length (${alignment.character_end_times_seconds.length}) ` +
            `doesn't match characters length (${charCount})`);
    }
    if (errors.length > 0) {
        return errors;
    }
    // Check for timing validity
    for (let i = 0; i < charCount; i++) {
        const startTime = alignment.character_start_times_seconds[i];
        const endTime = alignment.character_end_times_seconds[i];
        // Check for non-numeric values
        if (typeof startTime !== "number" || isNaN(startTime)) {
            errors.push(`character_start_times_seconds[${i}] is not a valid number`);
        }
        if (typeof endTime !== "number" || isNaN(endTime)) {
            errors.push(`character_end_times_seconds[${i}] is not a valid number`);
        }
        // Check for negative times
        if (startTime < 0) {
            errors.push(`character_start_times_seconds[${i}] is negative: ${startTime}`);
        }
        if (endTime < 0) {
            errors.push(`character_end_times_seconds[${i}] is negative: ${endTime}`);
        }
        // Check that end time >= start time
        if (endTime < startTime) {
            errors.push(`character_end_times_seconds[${i}] (${endTime}) < ` +
                `character_start_times_seconds[${i}] (${startTime})`);
        }
        // Check for monotonic increase (each character should start after or at the same time as previous)
        if (i > 0) {
            const prevStartTime = alignment.character_start_times_seconds[i - 1];
            if (startTime < prevStartTime) {
                errors.push(`character_start_times_seconds[${i}] (${startTime}) < ` +
                    `character_start_times_seconds[${i - 1}] (${prevStartTime}) - not monotonically increasing`);
            }
        }
    }
    return errors.length > 0 ? errors : null;
}
//# sourceMappingURL=media.js.map